import { useState } from 'react';
import { cn } from '@ideoz/ui';
import { StreamedArtifactSidePanel } from './StreamedArtifactSidePanel';
import type { MessageArtifact } from '@ideoz/core';

interface ArtifactPanelOverlayProps {
  artifact: MessageArtifact;
  onClose: () => void;
  onSave: (content: string) => Promise<void>;
  onSaveStructured: (json: Record<string, unknown>) => Promise<void>;
  onShare: () => Promise<void>;
}

/** Dumb: right-side drawer overlay wrapping the shared artifact panel. */
export function ArtifactPanelOverlay({
  artifact,
  onClose,
  onSave,
  onSaveStructured,
  onShare,
}: ArtifactPanelOverlayProps): JSX.Element {
  // Fullscreen widens the narrow (max-w-3xl) drawer to fill the viewport. We
  // drive it through the panel's existing conversation-panel toggle, which
  // already renders the Maximize2/Minimize2 button for exactly this purpose.
  const [isFullscreen, setIsFullscreen] = useState(false);

  return (
    <div className="fixed inset-0 z-40 flex justify-end bg-black/30" onClick={onClose}>
      <div
        className={cn('h-full w-full', isFullscreen ? 'max-w-none' : 'max-w-3xl')}
        onClick={(e) => e.stopPropagation()}
      >
        <StreamedArtifactSidePanel
          artifact={artifact}
          isOpen
          onClose={onClose}
          onToggleConversationPanel={() => setIsFullscreen((prev) => !prev)}
          isConversationPanelCollapsed={isFullscreen}
          onSave={artifact.id ? onSave : undefined}
          onSaveStructured={artifact.id ? onSaveStructured : undefined}
          onShare={artifact.id ? onShare : undefined}
        />
      </div>
    </div>
  );
}
